<template>
    <Modal v-model:visible="Visible">
        <template v-slot:header>
            <div>
                <h2 class="text-2xl font-bold" :class="{'text-center mb-5': status}">{{ Title }}</h2>
            </div>
            <Alert v-if="creazione_permission_denied" class="sticky top-0 z-10 bg-next-orange">Non hai i permessi sufficienti per poter creare un alert</Alert>
            <Alert v-if="modifica_permission_denied" class="sticky top-0 z-10 bg-next-orange">Non hai i permessi sufficienti per poter aggiornare un alert</Alert>
        </template>
        <template v-slot:main>
            <div v-if="status === 1" class="text-center text-2xl mb-5">
                {{ $filters.toDate(alert.scadenza) }}
            </div>
            <div v-else-if="status === 0" class="pt-5">
                <div class="flex flex-col mb-3">
                    <div class="font-bold">Titolo *</div>
                    <textarea v-model="alert.descrizione" placeholder="Titolo"
                              class="col-span-3 p-2 bg-next-gray-md h-36"></textarea>
                    <small v-for="(e,i) in getErrors('descrizione')" :key="i"
                           class="text-next-orange">{{ e }}</small>
                </div>
                <div class="flex mb-3 gap-3">
                    <div class="basis-1/2">
                        <div class="font-bold">Seleziona una data *</div>
                        <input v-model="alert.scadenza" type="date" :min="minDate"
                               class="col-span-3 p-2 bg-next-gray-md w-full">
                        <small v-for="(e,i) in getErrors('scadenza')" :key="i"
                               class="text-next-orange">{{ e }}</small>
                    </div>
                    <div class="basis-1/2">
                        <div class="font-bold">Giorni di preavviso</div>
                        <input v-model="alert.giorni_preavviso" type="number" :min="0"
                               class="col-span-3 p-2 bg-next-gray-md w-full">
                        <small v-for="(e,i) in getErrors('giorni_preavviso')" :key="i"
                               class="text-next-orange">{{ e }}</small>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div v-if="status === 0" class="flex justify-end pt-3 items-center">
                <p v-if="id" @click="status = 3" class="underline cursor-pointer">Elimina</p>
                <NextButton variant="outline-secondary"
                    @click="chiudi"
                    class="col-start-3 ml-4 py-2 px-4">
                    Chiudi
                </NextButton>
                <NextButton variant="primary"
                            :disabled="loading_button"
                            @click="handleSuccess"
                            class="py-2 px-4 ml-4 flex items-center justify-center">
                    <Spinner v-show="loading_button" class="w-4 h-4 mr-4"></Spinner>
                    {{ SuccessButtonLabel }}
                </NextButton>
            </div>
            <div v-else-if="status === 3" class="flex justify-center">
                <NextButton variant="outline-secondary"
                    @click="destroy"
                    class="ml-4 py-2 px-4">
                    Conferma
                </NextButton>
                <NextButton variant="primary"
                    @click="chiudi"
                    class="ml-4 py-2 px-4">
                    Chiudi
                </NextButton>
            </div>
            <div v-else class="flex justify-center">
                <NextButton variant="primary"
                    @click="chiudi"
                    class="ml-4 py-2 px-4">
                    Chiudi
                </NextButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import alertManager from "../api/Alert";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import moment from 'moment'
import Alert from './Alert.vue';
import NextButton from "@/components/NextButton.vue";
import clientiManager from "../api/Clienti";
import Spinner from "@/components/Spinner.vue";

@Options({
    name:'ModalAlert',
    components: {
        Spinner,
        NextButton,
        Modal,
        Alert
    },
    props: {
        visible: {
            type: Boolean,
            default: true
        },
        id: {
            type: [Number, String],
            default: 0
        },
        azienda_id: [String, Number],
        user_id: [String, Number],
        resultStatus: {
            type: Number,
            default: 0
        }
    }
})
export default class ModalAlert extends Vue {
    id!: number | string
    visible!: boolean
    loading = false
    loading_button = false
    creazione_permission_denied = false
    modifica_permission_denied = false
    cancellazione_permission_denied = false
    azienda_id!: string | number

    descrizione = ''
    scadenza = ''

    errors = {}
    alert: any = {
        descrizione: '',
        scadenza: '',
        giorni_preavviso: 7
    }

    resultStatus!:number

    get Visible() {
        return this.visible && !this.loading
    }

    get minDate() {
        return moment().format('YYYY-MM-DD')
    }

    get Title() {
        switch (this.status) {
            case 1:
                return 'L’alert manuale è ora attivo il giorno'
            case 2:
                return 'L’alert manuale è stato aggiornato'
            case 3:
                return 'Sei sicuro di voler cancellare questo alert?'
            case 4:
                return 'L’alert manuale è stato cancellato'
            default:
                if (this.id) {
                    return 'Modifica alert'
                }
                return 'Aggiungi un alert'
        }
    }

    get SuccessButtonLabel() {
        return this.id ? 'Aggiorna' : 'Aggiungi';
    }

    @Watch('id')
    loadAlert() {
        if (this.id) {
            this.loading = true
            alertManager.alert(this.id).then((response) => {
                this.alert = response.data
            }).catch(() => {
                this.alert = {}
            }).finally(() => {
                this.loading = false
            })
        } else {
            this.alert = {}
        }
    }

    handleSuccess() {
        if (this.id) {
            this.update()
        } else {
            this.add()
        }
    }

    add() {
        this.loading_button = true
        this.creazione_permission_denied = false
        this.modifica_permission_denied = false
        this.cancellazione_permission_denied = false
        clientiManager.alertCrate(this.azienda_id, {
            descrizione: this.alert.descrizione,
            scadenza: this.alert.scadenza,
            giorni_preavviso: this.alert.giorni_preavviso
        }).then((response) => {
            this.status = 1
            this.errors = {}
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            }
            if (res.response.status == 403) {
                this.creazione_permission_denied = true
            }
        }).finally(()=>{
            this.loading_button = false
        })
    }

    update() {
        this.loading_button = true
        this.creazione_permission_denied = false
        this.modifica_permission_denied = false
        this.cancellazione_permission_denied = false
        alertManager.alertUpdate(this.id, {
            descrizione: this.alert.descrizione,
            scadenza: this.alert.scadenza
        }).then((repsonse) => {
            this.status = 2
            this.errors = {}
        }).catch((res) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            }
            if (res.response.status == 403) {
                this.modifica_permission_denied = true
            }
        }).finally(()=>{
            this.loading_button = false
        })
    }

    destroy() {
        this.creazione_permission_denied = false
        this.modifica_permission_denied = false
        this.cancellazione_permission_denied = false
        alertManager.delete(this.id).then(() => {
            this.status= 4
        }).catch((res) => {
            if (res.response.status == 403) {
                this.cancellazione_permission_denied = true
            }
        })
    }

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    get status() {
        return this.resultStatus
    }

    set status(value: number) {
        this.$emit('update:resultStatus', value)
    }

    chiudi() {
        this.status = 0
        this.$emit('update:visible', false)
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
